module.exports = __webpack_public_path__ + "static/media/AttestationVerte.dabfd366.pdf";